type WishlistCardBodyProps = {
  title: string;
  description?: string;
};

const WishlistCardBody = ({ title, description }: WishlistCardBodyProps) => {
  return (
    <div className="wishlist-card-container">
      <h3>
        <span className="wishlist-card-title-text">{title}</span>
      </h3>
      {description ? (
        <p className="wishlist-card-text">{description}</p>
      ) : null}
    </div>
  );
};

export default WishlistCardBody;
